import cx from 'classnames';
import { BsX } from 'react-icons/bs';

import './notification.styles.scss';

const Notification = ({ notification, onDismiss }) => {
  if (!notification) {
    return null;
  }

  const { message, type } = notification;

  return (
    // `role="status"` fait lire le message par les lecteurs d'écran sans voler le
    // focus, contrairement à l'`alert()` du navigateur qui bloquait la page. Le
    // succès étant le cas par défaut, seule l'erreur porte un modificateur.
    <div
      className={cx('notification', { 'is-error': type === 'error' })}
      role="status"
    >
      <span className="notification-message">{message}</span>

      <button
        className="notification-close"
        type="button"
        onClick={onDismiss}
        aria-label="Fermer"
      >
        <BsX />
      </button>
    </div>
  );
};

export default Notification;
